import { AxiosRequestConfig } from 'axios';
import { isRelativeUrl } from './is-relative-url';

export function isSameOrigin(config: AxiosRequestConfig): boolean {
    const { baseURL = '', url = '' } = config;
    const isRelative = isRelativeUrl(config);

    if (isRelative && !baseURL) {
        return true;
    }

    const fullUrl = isRelative ? baseURL + url : url;
    if (!fullUrl) {
        return false;
    }

    return new URL(fullUrl, window.location.href).origin === window.location.origin;
}
